import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { LabeledSelect } from '../labeled-select'

export type SortByDateSelectProps = {
  value: number
  onChange: (value: 0 | 1) => void
  disabled?: boolean
  idSuffix?: string
  className?: string
  fluid?: boolean
}

export const SortByDateSelect: React.FC<SortByDateSelectProps> = ({
  value,
  onChange,
  disabled,
  idSuffix = 'default',
  className,
  fluid = false,
}) => {
  const { t } = useTranslation()
  const options = useMemo(
    () => [
      { value: 1 as const, label: t('ordersListPage.sortNewestFirst') as string },
      { value: 0 as const, label: t('ordersListPage.sortOldestFirst') as string },
    ],
    [t]
  )

  return (
    <LabeledSelect
      label={t('ordersListPage.sortByDate')}
      value={value as 0 | 1}
      options={options}
      onChange={onChange}
      disabled={disabled}
      idSuffix={idSuffix}
      className={className}
      fluid={fluid}
      minWidth={200}
    />
  )
}
